import { EmailTo } from 'components/EmailTo'
import { EmailTemplates } from 'pages/Admin/ConditionsAndTemplates/EmailTemplates'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { partiesMapWithAccountTypes } from 'reducers/loanDetail.reducer'
import { getBorrowerInfo } from 'services'
import { Modal, TextArea } from 'stories/components'
import { borrowerEmailParties, emailDirDefaults } from 'utils/borrowerRecipients'

export const BorroserEmailDialog = ({ onClose }: { onClose: Function }) => {
  const [loading, setLoading] = useState(false)
  const [note, setNote] = useState('')
  const [data, setData] = useState<{ party: string; email: string }[]>([])
  const [selectedEmails, setSelectedEmails] = useState<Record<string, 'to' | 'cc' | 'bcc' | ''>>({})
  const [showTemplate, setShowTemplate] = useState(false)
  const partiesMap = partiesMapWithAccountTypes()

  useEffect(() => {
    setLoading(true)
    getBorrowerInfo()
      .then(async ({ parties, borrowerEmail, borrowerAdditionalEmails }) => {
        // Offer and address every address the borrower keeps, not just the primary: sending the
        // budget to one address left the rest off a document the borrower has to sign.
        const borrowerParties = borrowerEmailParties({
          email: borrowerEmail,
          additionalEmails: borrowerAdditionalEmails,
        })
        const emails: { party: string; email: string }[] = [...borrowerParties]
        Object.keys(parties).forEach((key) => {
          if (key == 'accountManager') return
          let email = parties[key]
          if (!email) return

          emails.push({
            party: partiesMap[key],
            email,
          })
        })
        setData(emails)
        setSelectedEmails(emailDirDefaults(borrowerParties.map((row) => row.email)))
      })
      .finally(() => setLoading(false))
  }, [])

  const onSubmit = async () => {
    const hasToEmail = !!Object.keys(selectedEmails).filter((email) => selectedEmails[email] == 'to').length
    if (!hasToEmail) {
      toast('Please choose one more TO email.', { type: 'error' })
      return
    }

    setLoading(true)
    await onClose(true, selectedEmails, note)
    setLoading(false)
  }

  const onChooseTemplate = (template: any) => {
    setNote(template.content || '')
    setShowTemplate(false)
  }

  return (
    <>
      <Modal
        title={`Send Emails to ...`}
        titleOkay="Send Email"
        isOpen
        loading={loading}
        disabled={!Object.keys(selectedEmails).length}
        lastUpdatedAt={Date.now()}
        onClose={() => onClose(false)}
        onOk={() => onSubmit()}
      >
        <div className="w-144">
          <EmailTo Emails={selectedEmails} Data={data} onChange={(data: any) => setSelectedEmails(data)} />
          <div className="mt-4">
            <TextArea
              className=""
              title={'Notes'}
              key={'Notes'}
              rows={3}
              required
              value={note}
              onChange={(value: string) => setNote(value)}
              additionalElements={
                <span className="text-shade-blue hover:underline cursor-pointer" onClick={() => setShowTemplate(true)}>
                  Choose Template
                </span>
              }
            />
          </div>
        </div>
      </Modal>
      {showTemplate && (
        <Modal title="Email Template" titleOkay="" childLevel={2} onClose={() => setShowTemplate(false)} isOpen>
          <div className="min-w-[600px]">
            <EmailTemplates isModal onRawClick={onChooseTemplate} />
          </div>
        </Modal>
      )}
    </>
  )
}
